const BOT_LEVELS = [{label:'Kolay',difficulty:1},{label:'Orta',difficulty:3},{label:'Zor',difficulty:5}];
function botDifficultyLabel(value) { return BOT_LEVELS.find(level=>level.difficulty===value)?.label || ''; }
function botDifficultySuffix(value) { const label=botDifficultyLabel(value);return label ? ` · ${label}` : ''; }
module.exports={BOT_LEVELS,botDifficultyLabel,botDifficultySuffix};
